import React from 'react'
import CustomLink from '../components/CustomLink'
import AuthLayout from './AuthLayout'
import globals from '../globals'

class SwitchToNbn extends React.Component {
    render () {
        return (
            <AuthLayout
                title={globals.noWidows('Looking to upgrade to Exetel nbn™?')}
                description="If you’re an Exetel customer looking to upgrade to a nbn™ service, you can do so by logging into My Exetel and visiting the <span className='bold'>Upgrade to nbn™</span> page. You can get there by clicking the link below."
            >

                <CustomLink to='/upgrade-nbn'>
                    <div className='btn btn-custom'>Upgrade via My Exetel</div>
                </CustomLink>

                <div className='row'>
                    <div className='col-12 text-center mt-5'>
                        <small>Return to <CustomLink to='/login' className='return-to'>My Exetel</CustomLink></small>
                    </div>
                </div>
            </AuthLayout>
        )
    }
}

export default SwitchToNbn



// WEBPACK FOOTER //
// ./resources/js/auth/SwitchToNbn.js